
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-post/2021/05/skitch-not-working-on-mac",
      function () {
        return require("private-next-pages/blog-post/2021/05/skitch-not-working-on-mac.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-post/2021/05/skitch-not-working-on-mac"])
      });
    }
  